<template>
	<!-- rank wise table -->
	<div>
		<div data-html2canvas-ignore="true" class="customdim" v-show="loader || loaderStatus">
			<!-- <div class="spinner-border" role="status"><span class="sr-only">Loading...</span> </div> -->
			<Loader />
		</div>
		<div class="row datepickerwrap card" style=""
			v-if="viewBestSellersRankFiltereDataRankWise">
			<div class="d-flex justify-content-between align-items-center">
				<div class="d-flex align-items-center" style="width: 80%">
					<div class="customSelect mr-2">
						<div style="font-size:13px; margin-left:5px" class="mb-1 mt-2">{{ translatedLang["Date"][selectedLanguage.key] }}</div>
						<date-range-picker style="width: 150px;" v-model="dateRangeBestSellerRankWise"
							:show-dropdowns="true" opens='right' :autoApply="true"
							:locale-data="{ format: 'dd mmm yyyy' }" :min-date="bestSellerMinDateRankWise"
							:max-date="bestSellerMaxDateRankWise" :single-date-picker="true" :ranges="false">
						</date-range-picker>
					</div>
					<div class="customMultiselectCommon mt-1 mr-2">
						<div style="font-size:13px; margin-left:5px" class="mb-1">{{ translatedLang["Platform"][selectedLanguage.key] }}</div>
						<!-- <select class="form-control text-capitalize " style="height:34px" v-model="selectedPlatformRankWise"
              @change="filterCategoryDataRankWise(true)">
              <option style="height:30px" v-for="(d, i) in viewPlatformListRankWise" :key="i" :value="d"
                class="text-capitalize">
                {{ d }}</option>
            </select> -->
						<multiselect :custom-label="updateSelectedLabels" @input="filterCategoryDataRankWise(true)"
							v-model="selectedPlatformRankWise" :options="viewPlatformListRankWise" :multiple="false"
							:searchable="false" track-by="key" label="value" placeholder="Select Platform" :showLabels="false"
							:close-on-select="true" :allow-empty="false" class="text-capitalize">
							<template #option="{ option }">
								<div class="custom-option text-capitalize">
									<span>{{ option.value.replace('_', ' ') }}</span>
								</div>
							</template>
						</multiselect>
					</div>
					<div class="customMultiselectCommon mt-1 mr-2">
						<div style="font-size:13px; margin-left:5px" class="mb-1">{{ translatedLang["Category"][selectedLanguage.key] }}</div>
						<!-- <select class="form-control text-capitalize " style="height:34px" v-model="selectedCategoryRankWise"
              @change="filterSubCategoryDataRankWise(true)">
              <option style="height:30px" v-for="(d, i) in viewCategoryListRankWise" :key="i" :value="d"
                class="text-capitalize">{{ d }}</option>
            </select> -->
						<multiselect :custom-label="updateSelectedLabels" @input="filterSubCategoryDataRankWise(true)"
							v-model="selectedCategoryRankWise" track-by="key" label="value" :options="viewCategoryListRankWise" :multiple="false"
							:searchable="false" placeholder="Select Category" :showLabels="false"
							:close-on-select="true" :allow-empty="false" class="text-capitalize">
							<template #option="{ option }">
								<div class="custom-option text-capitalize">
									<span>{{ option.value.replace('_', ' ') }}</span>
								</div>
							</template>
						</multiselect>
					</div>
					<div class="customMultiselectCommon mt-1 mr-2" style="width: 200px">
						<div style="font-size:13px; margin-left:5px" class="mb-1">{{ translatedLang["Sub Category"][selectedLanguage.key] }}</div>
						<!-- <select class="form-control text-capitalize " style="height:34px" v-model="selectedSubCategoryRankWise">
              <option style="height:30px" v-for="(d, i) in viewSubCategoryListRankWise" :key="i" :value="d"
                class="text-capitalize">{{ d.replace('_', ' ') }}
              </option>
            </select> -->
						<multiselect :custom-label="updateSelectedLabels" v-model="selectedSubCategoryRankWise"
							:options="viewSubCategoryListRankWise" track-by="key" label="value" :multiple="false" :searchable="false"
							placeholder="Select Sub Category" :showLabels="false" :close-on-select="true"
							:allow-empty="false" class="text-capitalize">
							<template #option="{ option }">
								<div class="custom-option text-capitalize">
									<span>{{ option.value.replace('_', ' ') }}</span>
								</div>
							</template>
						</multiselect>
					</div>
					<!-- <div class="datebox customSelect">
                <div style="font-size:13px; margin-left:5px" class="mb-1">Price Range</div>
                <select class="form-control text-capitalize" style="height:34px" v-model="selectedPriceBand">
                  <option value="" style="height:30px">All</option>
                  <option style="height:30px" v-for="(d, i) in viewPriceBandList" :key="i" :value="d"
                    class="text-capitalize">{{ d }}
                  </option>
                </select>
              </div> -->
					<button class="btn primarycolor mt-4" type="button"
						style="height: 35px; padding: 3px 14px 4px;"
						@click="getBestSellerRankDataForRankWise(true)">
						<span style="font-size:14px">{{ translatedLang["Apply Filters"][selectedLanguage.key] }}</span>
					</button>
				</div>
				<div class="text-right">
					<div style="font-size: 12px !important;" v-if="storeRankWiseTableStatus"
						:class="[`mb-2 text-capitalize badge ${getClassStatusWise}`]">
						{{ storeRankWiseTableStatus }}
					</div>
					<div class="lastUpdated ml-2" :class="[!storeRankWiseTableStatus && 'mt-4']">
						{{ translatedLang["Last Updated"][selectedLanguage.key] }}: {{ bestSellerLastUpdatedDataDateRankWise }}
					</div>
				</div>
			</div>
		</div>
		<div class="mx-2 card">
			<table id="rankWiseBestSellerRankTable" ref="rankWiseTable"
				v-if="viewBestSellersRankTableBodyDataRankWise.length && tableRankWiseShowData">
				<thead>
					<tr>
						<th v-for="head of viewBestSellersRankTableHeaderDataRankWise" class="py-2"
							:class="{ 'product-name-column-rank': head.key === 'product_name','rank-column-class' : head.key === 'rank_delta' }">
							{{ head.label }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(td, index) of viewBestSellersRankTableBodyDataRankWise">
						<td v-for="head of viewBestSellersRankTableHeaderDataRankWise"
							:class="{ 'product-name-column-rank': head.key === 'product_name', 'rank-column-class' : head.key === 'rank_delta' }">
							<div v-if="head.key == 'product_name'">
								<a :href="td.product_link" target="_blank" class="text-capitalize">{{ td[head.key]
									}}</a>
							</div>
							<!-- <div v-else-if="head.key == 'brand_name'">
                    <div class="text-capitalize">{{ td[head.key] }}</div>
                  </div> -->
							<div v-else-if="head.key == 'rank'">
								<div class="text-capitalize">{{ td[head.key] }}</div>
							</div>
							<!-- <div v-else-if="head.key == 'rank_delta'" :class="{ 'delta-rank-colum': head.key === 'product_name' }">{{
                td[head.key] }}( was {{ td.rank - td[head.key] }})</div> -->

							<!-- <div v-else-if="head.key == 'rank_delta'" class="my-2">
								<span :class="{
									'delta-rank-down': td[head.key] > 0,
									'delta-rank-up': td[head.key] < 0
								}">
									{{ td[head.key] < 0 ? 'Rank up by' : 'Rank down by' }} {{ Math.abs(td[head.key]) }}
										<span>
										(was {{ td.rank -
											td[head.key] }})</span> </span>

							</div> -->
							<div v-else-if="head.key == 'rank_delta'" class="my-2 rank">
								<span :class="{
									'delta-rank-down': td[head.key] > 0,
									'delta-rank-up': td[head.key] < 0,
									'delta-rank-no-change': td[head.key] == 0
								}">
									{{ td[head.key] < 0 ? translatedLang["Rank up by"][selectedLanguage.key] : td[head.key] > 0 ? translatedLang["Rank down by"][selectedLanguage.key] : translatedLang["No change"][selectedLanguage.key]}} 
									 <span v-if="Math.abs(td[head.key]) !== 0">{{Math.abs(td[head.key]) }} (was {{ td.rank - td[head.key] }})</span> </span>

							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-else-if="!tableRankWiseShowData && loader" class="onLoadingData">{{ translatedLang["Loading"][selectedLanguage.key] }}...</div>
			<div v-else class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData">
				{{ translatedLang["No Data Available"][selectedLanguage.key] }}.
			</div>
		</div>
		<!-- <div class="row datepickerwrap card noData mt-3 border-red" v-else>No Data!</div> -->
	</div>
</template>


<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
// import Loader from '../Components/Loader.vue';
import Multiselect from "vue-multiselect";
import Loader from '../Components/Loader.vue';
import { mapState, mapActions } from "vuex";
// import Loader from '../Components/Loader.vue';
export default {
	name: 'SellerRankWiseTable',
	components: { Datepicker, Loader, Multiselect },

	data: function () {
		return {

			viewBestSellersRankTableBodyDataRankWise: [],
			viewBestSellersRankTableHeaderDataRankWise: [],
			viewBestSellersRankFiltereDataRankWise: '',
			selectedPlatformRankWise: '',
			selectedCategoryRankWise: '',
			selectedSubCategoryRankWise: '',
			bestSellerLastUpdatedDataDateRankWise: '',
			dateRangeBestSellerRankWise: {
				startDate: moment('08-31-2024').format("YYYY-MM-DD"),
				endDate: moment('08-31-2024').format("YYYY-MM-DD"),
			},
			bestSellerMinDateRankWise: '',
			bestSellerMaxDateRankWise: '',
			viewPlatformListRankWise: [],
			viewCategoryListRankWise: [],
			viewSubCategoryListRankWise: [],
			loader: true,

			storeAllDataForRankWiseTableStatus: {},
			loaderStatus: false,
			storeRankWiseTableStatus: '',

			tableRankWiseShowData: false
		}

	},

	mounted() {
		// this.destroyAllTables()
		// this.getLastUpdatedDates()
		this.dataAPIs()
	},

	computed: {
		...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
		getClassStatusWise() {
			return {
				completed: 'badge-success',
				failed: 'badge-danger',
				scheduled: 'badge-secondary',
				running: 'badge-light'
			}[this.storeRankWiseTableStatus]
		}
	},

	watch: {
		'selectedSubCategoryRankWise.key': function () {
			if (Object.keys(this.storeAllDataForRankWiseTableStatus).length) {
				this.storeRankWiseTableStatus = this.storeAllDataForRankWiseTableStatus[this.selectedPlatformRankWise.key.toLowerCase().replace(' ', '_')][this.selectedSubCategoryRankWise.key.replace('-', '_')]
			} else {
				this.storeRankWiseTableStatus = ''
			}
		},
		dateRangeBestSellerRankWise: {
			handler() {
				this.getAllStatusByApi();
			},
			deep: true
		}
	},

	methods: {
		...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
		// getLastUpdatedDates() {
		//   this.loader0 = true;

		//   const url = `/api/v2/india_clients/last_update?client=${this.client}`;
		//   this.$http.get(url).then(
		//     (response) => {
		//       if (response.body.data.best_sellers_ranking) {
		//         localStorage.best_sellers_ranking_last_update = JSON.stringify(response.body.data.best_sellers_ranking);
		//         this.dateRange.endDate = moment(response.body.data.best_sellers_ranking.end_date).format("YYYY-MM-DD");
		//         this.dateRange.startDate = moment(response.body.data.best_sellers_ranking.end_date).subtract(1, 'week').format("YYYY-MM-DD");
		//         this.maxDate = new Date(response.body.data.best_sellers_ranking.end_date);
		//         this.minDate = new Date(response.body.data.best_sellers_ranking.start_date)
		//         this.lastUpdated = `${moment(
		//           response.body.data.best_sellers_ranking.end_date
		//         ).format("DD MMM, YYYY")} ${response.body.data.best_sellers_ranking.latest_time ? "at" : ""
		//           } ${response.body.data.best_sellers_ranking.latest_time}`;
		//         this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);

		//       }
		//       this.loader0 = false;
		//       this.dataAPIs()
		//     },
		//     (err) => {
		//       this.loader0 = false;
		//       this.dataAPIs()
		//       console.log("err");
		//     }
		//   );
		// },
		dataAPIs() {
			this.getBestSellerRankDataForRankWise(false);
		},

		// formatDates() {
		//   this.dateRange.startDate = moment(this.dateRange.startDate).format('YYYY-MM-DD')
		//   this.dateRange.endDate = moment(this.dateRange.endDate).format('YYYY-MM-DD')

		// },
		// dateChange() {
		//   this.formatDates();
		// },

		updateSelectedLabels(option) {
			return option.value.replace('_', ' ')
		},



		processrankWiseBestSellerRankTableData() {
			const tableElement = document.querySelector("#rankWiseBestSellerRankTable");
			if ($.fn.DataTable.isDataTable('#rankWiseBestSellerRankTable')) {
				$('#rankWiseBestSellerRankTable').DataTable().clear().destroy();
			}
			// $("#rankWiseBestSellerRankTable").dataTable();
			this.$nextTick(() => {
				$("#rankWiseBestSellerRankTable").DataTable({
					autoWidth: false,
					language: {
						search: "",
						paginate: {
							first: "",
							previous: "<",
							next: ">",
							last: "",
						},
						lengthMenu: "<h5>Show entries</h5> _MENU_",
					},
					pagingType: "full_numbers",
				});
				let search = require("../../../public/Icons_SVG/Search.svg");
				$("#rankWiseBestSellerRankTable_filter > label > input").attr("placeholder", "Search");
				$("#rankWiseBestSellerRankTable_filter > label").append(`<div><img src='${search}' width='17'/></div>`);
				$("#rankWiseBestSellerRankTable_length > label > select").removeClass();
			})
			// }
		},


		getBestSellerRankDataForRankWise(applyFilter) {
			const tableElement = document.querySelector("#rankWiseBestSellerRankTable");
			let self = this
			self.tableRankWiseShowData = false;
			self.viewBestSellersRankTableBodyDataRankWise = []
			self.viewBestSellersRankTableHeaderDataRankWise = []
			self.loader = true
			let payload = {
                language: this.$store.state.DemoStore.selectedLanguage.key,
            }
			let url = "/api/v2/brand/bestsellersranks";
			if (applyFilter) {
				payload.extract_date = moment(self.dateRangeBestSellerRankWise.startDate).format("YYYY-MM-DD"),
					payload.category = this.selectedSubCategoryRankWise.key,
					payload.plateform = this.selectedPlatformRankWise.key
				if ($.fn.DataTable.isDataTable('#rankWiseBestSellerRankTable')) {
					$('#rankWiseBestSellerRankTable').DataTable().clear().destroy();
				}
			}

			self.$http.post(url, payload).then(response => {
				self.tableRankWiseShowData = response.data.data_present;
				self.viewBestSellersRankTableHeaderDataRankWise = response.data.data.headers
				self.viewBestSellersRankTableBodyDataRankWise = response.data.data.sellerRankData
				if (!applyFilter) {
					self.bestSellerLastUpdatedDataDateRankWise = moment(response.data.data.updated_dates.last_updated).format("DD MMM, YYYY")
					self.dateRangeBestSellerRankWise.startDate = moment(response.data.data.updated_dates.last_updated).format("YYYY-MM-DD")
					self.dateRangeBestSellerRankWise.endDate = moment(response.data.data.updated_dates.last_updated).format("YYYY-MM-DD")
					self.bestSellerMinDateRankWise = new Date(response.data.data.updated_dates.start_date);
					self.bestSellerMaxDateRankWise = new Date(response.data.data.updated_dates.end_date);
					self.viewBestSellersRankFiltereDataRankWise = response.data.data.filters_new
					self.selectedPlatformRankWise = response.data.data.selected_category_new.plateform
					self.selectedCategoryRankWise = response.data.data.selected_category_new.sub_category1
					self.selectedSubCategoryRankWise = response.data.data.selected_category_new.sub_category2
					this.processBestSellerFilterRankWise(false);
					// if (this.selectedPlatformRankWise && this.selectedSubCategoryRankWise) {
					// 	this.getAllStatusByApi();
					// }

				}
				// this.$nextTick(() => {
				const tableElement = document.querySelector("#rankWiseBestSellerRankTable");
				// if (tableElement) {
				//   console.log("Table Element Found:", tableElement);

				// $("#rankWiseBestSellerRankTable").DataTable().destroy();
				// if(tableElement){

				self.processrankWiseBestSellerRankTableData();

				// }

				self.loader = false;

				// })
			}).catch(err => {
				self.loader = false
				console.log('err')
			});
		},

		getAllStatusByApi() {
			let self = this;
			self.loaderStatus = true;
			const url = 'api/v2/sensespiderstatus'
			let payload = {
				// "client_id": "1e5b11d71bf84ee7ac584db27d458389",
				timestamp: moment(this.dateRangeBestSellerRankWise.endDate).format("YYYY-MM-DD"),
				feature: 'pincode'
			}
			self.$http.post(url, payload).then((response) => {
				self.storeAllDataForRankWiseTableStatus = response.body.data;
				if (Object.keys(self.storeAllDataForRankWiseTableStatus).length) {
					self.storeRankWiseTableStatus = self.storeAllDataForRankWiseTableStatus[self.selectedPlatformRankWise.key.toLowerCase().replace(' ', '_')][self.selectedSubCategoryRankWise.key.replace('-', '_')]
				} else {
					self.storeRankWiseTableStatus = ''
				}
				self.loaderStatus = false;
			}).catch(err => {
				console.log(err)
				self.loaderStatus = false;
			})
		},



		processBestSellerFilterRankWise(applyFilter) {
			this.viewPlatformListRankWise = []
            this.viewPlatformListRankWise = this.viewBestSellersRankFiltereDataRankWise.platform;
            
			// Object.entries(this.viewBestSellersRankFiltereDataRankWise).forEach(([key, value]) => {
			// 	this.viewPlatformListRankWise.push(key)
			// })

			if (applyFilter){
                this.selectedPlatformRankWise = this.viewPlatformListRankWise[0]
            }
			
			this.filterCategoryDataRankWise(applyFilter)
		},

		filterCategoryDataRankWise(applyFilter) {
			if (Object.keys(this.storeAllDataForRankWiseTableStatus).length) {
				this.storeRankWiseTableStatus = this.storeAllDataForRankWiseTableStatus[this.selectedPlatformRankWise.key.toLowerCase().replace(' ', '_')][this.selectedSubCategoryRankWise.key.replace('-', '_')]
			} else {
				this.storeRankWiseTableStatus = ''
			}
			this.viewCategoryListRankWise = []
			// Object.entries(this.viewBestSellersRankFiltereDataRankWise[this.selectedPlatformRankWise]).forEach(([key, value]) => {
			// 	this.viewCategoryListRankWise.push(key)
			// })
            this.viewCategoryListRankWise = this.viewBestSellersRankFiltereDataRankWise.sub_category1
			if (applyFilter)
				this.selectedCategoryRankWise = this.viewCategoryListRankWise[0]
			this.filterSubCategoryDataRankWise(applyFilter)
		},

		filterSubCategoryDataRankWise(applyFilter) {
			this.viewSubCategoryListRankWise = []
			// Object.entries(this.viewBestSellersRankFiltereDataRankWise[this.selectedPlatformRankWise][this.selectedCategoryRankWise]).forEach(([key, value]) => {
			// 	this.viewSubCategoryListRankWise.push(key)
			// })
            this.viewSubCategoryListRankWise = this.viewBestSellersRankFiltereDataRankWise.sub_category2
			if (applyFilter)
				this.selectedSubCategoryRankWise = this.viewSubCategoryListRankWise[0]
			// this.filterPriceBandData(applyFilter);
		},



	}
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card {
	border-radius: 0.7rem !important;
	border: none !important;
	margin-bottom: 1rem;
}

.lastUpdated {
	color: #065559;
	font-size: 12px;
	padding: 6px 12px;
	border: 1px solid var(--base_color-80);
	border-radius: 6px;
}

button.primarycolor {
	background: var(--primary_brand);
	font-family: "Poppins", sans-serif;
	color: white;
	padding: 5px 25px;
	border-radius: 6px;
	letter-spacing: 0.2px;
	font-weight: bold;
	font-size: 16px;
}

button.primarycolor:hover {
	color: white;
	background: var(--primary_brand-80);
	/* border: 1.6px solid var(--base_color); */
}

.form-control {
	font-size: 12px !important;
}

select {
	font-family: "Poppins", sans-serif;
}

select {
	border-radius: 5px !important;
}

select option {
	text-transform: capitalize;
	padding: 10px 0px;
}

.customSelect:focus {
	background: var(--base_color-5);
	color: var(--primary_brand-60);
	border: 1px solid var(--primary_brand-60) !important;
	outline: none;
	box-shadow: none;
	font-weight: 600;
}

.form-control:focus {
	box-shadow: none !important;
}

.product-name-column-rank {
	width: 70% !important;
	padding: 5px !important;
}

span.delta-rank-up {
	background: #DCFCE7;
	color: #15803D !important;
	padding: 3px 16px !important;
	border-radius: 5px !important;
	font-size: 14px !important;
	font-weight: 500 !important;
}

span.delta-rank-down {
	background: #FEE2E2;
	color: #B91C1C !important;
	padding: 3px 16px !important;
	border-radius: 5px !important;
	font-size: 14px !important;
	font-weight: 500 !important;
}

span.delta-rank-no-change {
    font-size: 14px !important;
    font-weight: 500 !important;
    background: #eee !important;
    padding: 3px 16px !important;
    border-radius: 5px !important;
    color: #7e7e7e !important;
}

.rank-column-class{
    width: 17rem !important;
}
</style>